import { gql } from 'graphql-tag'
import {
  fragmentModuleMedia,
  fragmentModuleInternalVideo,
  fragmentModuleNavigationLink
} from '../../../../core/data-layer/modules/fragments'
import { fragmentGlobalDataTheme } from '../../../../core/data-layer/global-data/fragments'

export default gql`
  ${fragmentModuleMedia}
  ${fragmentModuleInternalVideo}
  ${fragmentGlobalDataTheme}
  ${fragmentModuleNavigationLink}
  fragment BlockStoryFragment on BlockStory {
    sys {
      id
    }
    subtitle
    title
    author
    authorInfo
    media {
      ... on ModuleInternalVideo {
        ...ModuleInternalVideoFragment
      }
      ... on ModuleMedia {
        ...ModuleMediaFragment
      }
    }
    theme {
      ...GlobalDataThemeFragment
    }
    link {
      ...ModuleNavigationLinkFragment
    }
  }
`
